enum RotateDirection {
  CLOCKWISE = 1,
  COUNTERCLOCKWISE = -1,
}

export default RotateDirection;
